import React, {Component} from 'react';
import {Menu} from 'semantic-ui-react';
import {NavLink, Route, Redirect, Switch} from 'react-router-dom';

import Page from '../layout/Page';
import Favorites from './Favorites';
import SearchHistory from './SearchHistory';
import SearchResults from './SearchResults';

class IndexScreen extends Component {
  state = {};

  render() {
    return (
      <Page.Basic
        title="Product Documentation"
        secondary={
          <Menu secondary pointing>
            <Menu.Item as={NavLink} to="/product-documentation/favorites" exact>
              Favorites
            </Menu.Item>
            <Menu.Item as={NavLink} to="/product-documentation/search-history">
              View History
            </Menu.Item>
          </Menu>
        }
      >
        <Switch>
          <Route
            path="/product-documentation/favorites"
            component={Favorites}
          />
          <Route
            path="/product-documentation/search-history"
            component={SearchHistory}
          />
          <Route
            path="/product-documentation/search"
            component={SearchResults}
          />
          <Redirect to="/product-documentation/favorites" />
        </Switch>
      </Page.Basic>
    );
  }
}

export default IndexScreen;
